<header class="header">
  <nav class="top-nav">
    <div routerLink="/" class="logo-container">
      <img src="../../../assets/calculator_icon.svg" alt="Flyff logo" class="icon" />
      <a class="logo" routerLink="/">Flyff Calculators</a>
    </div>

    <!-- Toggle Button for Mobile -->
    <button class="menu-toggle" (click)="toggleMenu()">
      ☰
    </button>

    <!-- Navigation Links -->
    <ul class="nav-links" [class.active]="isMenuOpen">
      <li><a class="nav-item" routerLink="/gear" (click)="closeMenu()">Gear upgrade</a></li>
      <li><a class="nav-item" routerLink="/jewels" (click)="closeMenu()">Jewel upgrade</a></li>
      <li><a class="nav-item" routerLink="/ulti-weapon" (click)="closeMenu()">Ultimate weapon upgrade</a></li>
      <li><a class="nav-item" routerLink="/ulti-jewels" (click)="closeMenu()">Ultimate jewel upgrade</a></li>
      <li><a class="nav-item" routerLink="/1h-weapon-piercing" (click)="closeMenu()">1h weapon piercing</a></li>
      <li><a class="nav-item" routerLink="/2h-weapon-piercing" (click)="closeMenu()">2h weapon piercing</a></li>
      <li><a class="nav-item" routerLink="/suit-piercing" (click)="closeMenu()">Suit piercing</a></li>
      <li><a class="nav-item" routerLink="/daily-calculator" (click)="closeMenu()">Daily calculator</a></li>

      <!-- Desktop-only: Beta dropdown -->
      <!-- <li class="beta-desktop-menu">
        <span class="nav-item">Beta</span>
        <ul class="beta-dropdown">
          <li>
            <a class="nav-item" routerLink="/beta/daily-calculator" (click)="closeMenu()">
              Daily calculator (beta)
            </a>
          </li>
          <li>
            <a class="nav-item" routerLink="/beta/ulti-weapon" (click)="closeMenu()">
              Ultimate weapon upgrade (beta)
            </a>
          </li>
          <li>
            <a class="nav-item" routerLink="/beta/ulti-jewels" (click)="closeMenu()">
              Ultimate jewel upgrade (beta)
            </a>
          </li>
        </ul>
      </li> -->

      <!-- Mobile-only: individual beta items in hamburger -->
      <!-- <li class="beta-mobile-item">
        <a class="nav-item" routerLink="/beta/daily-calculator" (click)="closeMenu()">
          [BETA] Daily calculator
        </a>
      </li>
      <li class="beta-mobile-item">
        <a class="nav-item" routerLink="/beta/ulti-weapon" (click)="closeMenu()">
          [BETA] Ultimate weapon upgrade
        </a>
      </li>
      <li class="beta-mobile-item">
        <a class="nav-item" routerLink="/beta/ulti-jewels" (click)="closeMenu()">
          [BETA] Ultimate jewel upgrade
        </a>
      </li> -->
    </ul>

  </nav>
</header>
